import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { officeLocations } from '../data/mockData';
import { MapPin } from 'lucide-react';

const Zones = () => {
  const { t } = useLanguage();

  const regionImages = [
    'https://images.unsplash.com/photo-1485738422979-f5c462d49f74?w=800&h=600&fit=crop', // New York
    'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=800&h=600&fit=crop', // Paris
    'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=800&h=600&fit=crop', // London
    'https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=800&h=600&fit=crop', // Berlin
    'https://images.unsplash.com/photo-1515542622106-78bda8ba0e5b?w=800&h=600&fit=crop', // Rome
    'https://images.unsplash.com/photo-1543783207-ec64e4d95325?w=800&h=600&fit=crop', // Madrid
    'https://images.unsplash.com/photo-1517935706615-2717063c2225?w=800&h=600&fit=crop', // Toronto
    'https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?w=800&h=600&fit=crop'  // Sydney
  ];

  return (
    <div className="min-h-screen bg-[#0a0a0a] py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <h1 className="text-5xl md:text-6xl font-light text-white mb-6 tracking-wide">
            {t.regions.title}
          </h1>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto leading-relaxed">
            {t.regions.subtitle}
          </p>
        </div>

        {/* Regions Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-24">
          {t.regions.items.map((region, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-lg bg-gray-900 border border-gray-800 hover:border-[#d4c5a9]/50 transition-all duration-300 hover:scale-[1.02]"
            >
              {/* Background Image */}
              <div className="absolute inset-0">
                <img
                  src={regionImages[index]}
                  alt={region.name}
                  className="w-full h-full object-cover opacity-20 group-hover:opacity-30 transition-opacity duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/80 to-black/40" />
              </div>

              {/* Content */}
              <div className="relative z-10 p-8 min-h-[300px] flex flex-col justify-end">
                <h3 className="text-3xl font-light text-white mb-4 group-hover:text-[#d4c5a9] transition-colors">
                  {region.name}
                </h3>
                <p className="text-gray-300 leading-relaxed">
                  {region.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Offices Section */}
        <div className="mt-24">
          <h2 className="text-4xl font-light text-white text-center mb-12 tracking-wide">
            Nos bureaux internationaux
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {officeLocations.map((office, index) => (
              <div
                key={index}
                className="group relative aspect-square overflow-hidden rounded-lg border border-gray-800 hover:border-[#d4c5a9]/50 transition-all duration-300"
              >
                <img
                  src={office.image}
                  alt={office.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
                <div className="absolute inset-0 p-4 flex flex-col justify-end">
                  <div className="flex items-center gap-2 text-white">
                    <MapPin className="w-4 h-4 text-[#d4c5a9]" />
                    <span className="font-medium">{office.name}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Zones;